export const FIELD_TYPES = [
  { type: "text", label: "Text" },
  { type: "textarea", label: "Textarea" },
  { type: "select", label: "Select" },
  { type: "checkbox", label: "Checkbox" },
  { type: "yesno", label: "Yes / No" },
  { type: "photo", label: "Photo" },
];

export const TEMPLATE_TYPES = [
  { value: "inspection", label: "Inspection" },
  { value: "site_survey", label: "Site Survey" },
  { value: "checklist", label: "Checklist" },
  { value: "opname", label: "Installation Survey" },
];

export function createDefaultTemplate() {
  return {
    id: "",
    name: "",
    description: "",
    type: "inspection",
    category: "GENERAL",
    status: "draft",
    sections: [createSection("Algemeen")],
  };
}

export function createSection(title = "Nieuwe sectie") {
  return {
    id: uid("sec"),
    title,
    repeatable: false,
    fields: [],
  };
}

export function createField(type = "text") {
  const normalized = String(type || "text").toLowerCase();
  return {
    id: uid("fld"),
    type: normalized,
    label: `${toTitle(normalized)} vraag`,
    required: false,
    placeholder: "",
    options: normalized === "select" ? ["Optie 1", "Optie 2"] : [],
    multiple: normalized === "photo",
  };
}

export function hydrateTemplateFromApi(template, definition) {
  const base = createDefaultTemplate();
  const sections = Array.isArray(definition?.sections)
    ? definition.sections.map((section, sectionIndex) => ({
        id: String(section?.id || uid(`sec_${sectionIndex + 1}`)),
        title: String(section?.title || `Sectie ${sectionIndex + 1}`),
        repeatable: Boolean(section?.repeatable),
        fields: Array.isArray(section?.fields)
          ? section.fields.map((field, fieldIndex) => ({
              id: String(field?.id || uid(`fld_${sectionIndex + 1}_${fieldIndex + 1}`)),
              type: String(field?.type || "text").toLowerCase(),
              label: String(field?.label || "Veld"),
              required: Boolean(field?.required),
              placeholder: String(field?.placeholder || ""),
              options: Array.isArray(field?.options)
                ? field.options.map((item) => String(item || "")).filter(Boolean)
                : [],
              multiple: Boolean(field?.multiple),
            }))
          : [],
      }))
    : base.sections;

  return {
    ...base,
    id: String(template?._id || ""),
    name: String(template?.name || ""),
    description: String(template?.description || ""),
    type: String(template?.type || base.type),
    category: String(template?.category || base.category),
    status: String(template?.status || "draft"),
    sections,
  };
}

export function toTemplatePayload(template) {
  return {
    name: String(template?.name || "").trim(),
    description: String(template?.description || "").trim(),
    type: String(template?.type || "inspection"),
    category: String(template?.category || "GENERAL").trim().toUpperCase(),
    status: "draft",
    sections: Array.isArray(template?.sections)
      ? template.sections.map((section) => ({
          id: String(section?.id || uid("sec")),
          title: String(section?.title || "Nieuwe sectie"),
          repeatable: Boolean(section?.repeatable),
          fields: Array.isArray(section?.fields)
            ? section.fields.map((field) => ({
                id: String(field?.id || uid("fld")),
                type: String(field?.type || "text").toLowerCase(),
                label: String(field?.label || "Veld"),
                required: Boolean(field?.required),
                placeholder: String(field?.placeholder || ""),
                options: Array.isArray(field?.options)
                  ? field.options.map((item) => String(item || "")).filter(Boolean)
                  : [],
                multiple: Boolean(field?.multiple),
              }))
            : [],
        }))
      : [],
  };
}

export function toTitle(value = "") {
  return String(value || "")
    .replace(/[_-]+/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());
}

export function uid(prefix = "id") {
  const rand = Math.random().toString(36).slice(2, 9);
  return `${prefix}_${Date.now().toString(36)}_${rand}`;
}

export function parseFieldDragId(id = "") {
  const raw = String(id || "");
  if (!raw.startsWith("field:")) return null;
  const parts = raw.split(":");
  if (parts.length < 3) return null;
  return { sectionId: parts[1], fieldId: parts.slice(2).join(":") };
}

export function parseSectionDragId(id = "") {
  const raw = String(id || "");
  if (!raw.startsWith("section:")) return null;
  return { sectionId: raw.slice("section:".length) };
}

export function parsePaletteDragId(id = "") {
  const raw = String(id || "");
  if (!raw.startsWith("palette:")) return null;
  return { fieldType: raw.slice("palette:".length) };
}

export function resolveTargetSectionId(overId = "") {
  const field = parseFieldDragId(overId);
  if (field) return field.sectionId;
  const section = parseSectionDragId(overId);
  if (section) return section.sectionId;
  const drop = String(overId || "");
  if (drop.startsWith("drop-section:")) {
    return drop.slice("drop-section:".length);
  }
  return "";
}
